import { render, staticRenderFns } from "./EmailCreate.vue?vue&type=template&id=f822efd4"
import script from "./EmailCreate.vue?vue&type=script&lang=ts"
export * from "./EmailCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports